import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
  useEffect,
} from 'react';
import ACTIONPLANAPI from '@/apps/nnc/services/actionplan';
import ACTIONSAPI from '@/apps/nnc/services/actionplanactions';

interface NotificationCounts {
  tasks: number;
  [key: string]: number;
}

interface NotificationContextType {
  notifications: NotificationCounts;
  fetchNotifications: () => Promise<void>;
}

const initialNotifications: NotificationCounts = {
  tasks: 0,
};

const NotificationContext = createContext<NotificationContextType | undefined>(
  undefined,
);

interface NotificationProviderProps {
  children: ReactNode;
  apiBaseUrl?: string;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
  children,
  apiBaseUrl = '/api',
}) => {
  const [notifications, setNotifications] =
    useState<NotificationCounts>(initialNotifications);

  const fetchNotifications = useCallback(async (): Promise<void> => {
    try {
      const actionPlanResponse = await ACTIONPLANAPI.tasks();
      const actionResponse = await ACTIONSAPI.tasks();
      setNotifications({
        tasks: actionPlanResponse.data.length + actionResponse.data.length || 0,
      });
    } catch (err) {
      console.error('Erro ao buscar notificações:', err);
    }
  }, [apiBaseUrl]);

  const value: NotificationContextType = {
    notifications,
    fetchNotifications,
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

/* eslint-disable react-refresh/only-export-components */
export const useNotifications = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error(
      'useNotifications deve ser usado dentro de um NotificationProvider',
    );
  }
  return context;
};
